import { bunja } from 'bunja';
import { atom } from 'jotai';

// ROLLBACK(last-price): 재활성화 시 아래 import 복원.
// import { getLocalStorageAtom } from '@flipster/react/misc/state/use-local-storage';
// import { getFlipsterConfigsV1Key } from '@flipster/utils/localStorage';
//
// import { authBunja } from '../auth/state';

export const upnlBasisEnum = {
  mark: 'mark',
  last: 'last',
  bbo: 'bbo',
} as const;

export type UpnlBasis = (typeof upnlBasisEnum)[keyof typeof upnlBasisEnum];

/** Legacy `unrealizedPnl` / `netPnl` align with BBO until the user picks Mark or Last. */
export const defaultUpnlBasis = upnlBasisEnum.bbo;

export const upnlBasisBunja = bunja(() => {
  // ROLLBACK(last-price): MM 준비 완료 시 재활성화 — MM 미준비로 basis 선택을 비활성화하고
  // 항상 기본값(bbo — legacy `unrealizedPnl`/`netPnl`과 동일 수치)을 사용한다.
  // 재활성화 시 아래 원본(사용자별 localStorage 저장/복원)을 살리고 임시 atom을 제거할 것.
  //
  // const { userAtom } = bunja.use(authBunja);
  //
  // const upnlBasisAtom = atom(
  //   (get) => {
  //     const user = get(userAtom);
  //     if (!user) return defaultUpnlBasis;
  //
  //     const key = getFlipsterConfigsV1Key(user.userId, 'upnlBasis');
  //     const localStorageAtom = getLocalStorageAtom(key, defaultUpnlBasis);
  //     return get(localStorageAtom);
  //   },
  //   (get, set, newValue: UpnlBasis) => {
  //     const user = get(userAtom);
  //     if (!user) return;
  //
  //     const key = getFlipsterConfigsV1Key(user.userId, 'upnlBasis');
  //     const localStorageAtom = getLocalStorageAtom(key, defaultUpnlBasis);
  //     set(localStorageAtom, newValue);
  //   },
  // );

  // 쓰기 시그니처는 유지하되 no-op — 소비처 코드 변경 없이 basis를 bbo로 고정한다.
  const upnlBasisAtom = atom(
    () => defaultUpnlBasis,
    (_get, _set, _newValue: UpnlBasis) => {},
  );

  return {
    upnlBasisAtom,
  };
});

upnlBasisBunja.debugLabel = 'upnlBasisBunja';
